/**
 * Alternative to IS_TOUCH_DEVICE which can distinguish mobile from touch screen laptops
 */
export const HAS_MOUSE_SUPPORT = window.matchMedia('(pointer:fine)').matches
